import type { TargetCandidate } from "../TargetCandidate";

const DEPTH_EPSILON = 1e-4;

/** Resolves the object that is actually in front on screen, independent of picker order. */
export function resolveVisualTarget(
  candidates: readonly (TargetCandidate | null | undefined)[],
): TargetCandidate | null {
  return (
    candidates
      .filter((value): value is TargetCandidate => Boolean(value))
      .sort((a, b) => {
        const depthDelta = a.depth - b.depth;
        if (Math.abs(depthDelta) > DEPTH_EPSILON) return depthDelta;
        const priorityDelta = b.priority - a.priority;
        if (priorityDelta) return priorityDelta;
        return a.screenDistance - b.screenDistance;
      })[0] ?? null
  );
}
